import type { AdminKpisPdfExportViewProps } from "../../models/admin-kpis.models";
import AdminKpisPdfSection from "./AdminKpisPdfSection";
import AdminKpisPdfTrendLine from "./AdminKpisPdfTrendLine";
import { memo } from "react";

const AdminKpisPdfExportView = ({
  environment,
  periodFleetCertificateStatus,
  periodFleetBalticQuestionnaireStatus,
  activeTrendFilter,
  dailySnapshotHistory,
  selectedTrendWindow,
}: AdminKpisPdfExportViewProps) => (
  <div className="admin-kpis-print-export" data-test="admin-kpis-pdf-export-view" aria-hidden="true">
    <div className="admin-kpis-print-page">
      <header className="admin-kpis-print-header">
        <h1>Certificates Management</h1>
        <div className="admin-kpis-print-environment">Snowflake Environment: {environment}</div>
      </header>

      <div className="admin-kpis-print-charts">
        <AdminKpisPdfSection title="Period Fleet Certificates" section={periodFleetCertificateStatus} />
        <AdminKpisPdfSection title="Period Fleet Baltic Questionnaire" section={periodFleetBalticQuestionnaireStatus} />
      </div>

      <AdminKpisPdfTrendLine
        activeFilter={activeTrendFilter}
        history={dailySnapshotHistory}
        periodFleetCertificateStatus={periodFleetCertificateStatus}
        periodFleetBalticQuestionnaireStatus={periodFleetBalticQuestionnaireStatus}
        selectedWindow={selectedTrendWindow}
      />
    </div>
  </div>
);

export default memo(AdminKpisPdfExportView);
